  document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.getElementById('social-bubble-toggle');
    var icons = document.getElementById('social-bubble-icons');
    if (!toggle || !icons) return;

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = icons.classList.toggle('open');
      if (isOpen) {
        toggle.classList.add('active');
      } else {
        toggle.classList.remove('active');
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('#social-bubble-wrapper')) {
        icons.classList.remove('open');
        toggle.classList.remove('active');
      }
    });
  });